import type { PrintSelectionPreviewRow } from "../../../../../../../_shared/_logic/print-selection-preview"

export type PrintSelectionValue = "yes" | "no"
export type PrintSelectionState = Record<string, PrintSelectionValue>

export const initialPrintSelection = (rows: PrintSelectionPreviewRow[]): PrintSelectionState =>
  Object.fromEntries(
    rows.map((row) => [
      row.letter_delivery_batch_item_id,
      row.recommended_print && row.printable ? "yes" : "no",
    ]),
  )

export const selectedPrintableItemIds = (
  rows: PrintSelectionPreviewRow[],
  selection: PrintSelectionState,
): string[] =>
  rows
    .filter((row) => row.printable && selection[row.letter_delivery_batch_item_id] === "yes")
    .map((row) => row.letter_delivery_batch_item_id)
